import React from 'react';
import {connect} from 'react-redux';
import Layout from '~/Components/Layout/Layout';
import {Link} from "react-router-dom";
import StatusPending from "./StatusPending";
import StatusDeclined from "./StatusDeclined";
import StatusConfirmed from "./StatusConfirmed";
import RegisterShortcut from '../../Components/RegisterShortcut/RegisterShortcut';
import NoInvitation from './NoInvitation';

import './invitation.scss';
import Moment from "react-moment";
import placeholder from "~/assets/placeholder-image.svg";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import Translate from "~/Components/ContentTranslate/Translate";

const Invitation = ({currentLanguage, ...props}) => {

    if (!props.invitation_loaded) {
        return <></>;
    }

    if (!props.invitation) {
        return <NoInvitation />;
    }

    const event = props.invitation.event;
    const wave = props.invitation.wave;
    const containerStyle = {backgroundImage: `url(${event.invitation_image?.download_url || placeholder})`};

    return (
        <Layout containerStyle={containerStyle} noPadding page="invitation">
            <div className="container container-invitation">

                <div className="row">

                    <div className="col-lg-9 col-12">

                        <div className="row">
                            <div className="col-lg-7 col-12 col-left">
                                <h3 className="mb-0 tracking-200">
                                    {props.invitation?.rsvp_status === 'declined' ? 
                                        <TextTranslate name="invitation-youwereinvited" fallback="You were invited to" textOnly/> :
                                        <TextTranslate name="invitation-youareinvited" fallback="You are invited to" textOnly/>
                                    }
                                </h3>
                                <h1><Translate model={event} field="name" /></h1>
                                <img src={event.invitation_image?.download_url || placeholder} alt="Formula introduction image" className="d-lg-none d-block intro-image"/>
                                <div className="settings">
                                    <StatusPending invitation={props.invitation}>
                                        <div className="invitation-intro">
                                            <p className="pre-line">
                                                {event?.translations?.invitation_copy ?
                                                    event?.translations?.invitation_copy[currentLanguage.id]
                                                    :
                                                    event?.invitation_copy
                                                }
                                            </p>
                                            <Link to="/experience" className="link text-primary">
                                                <TextTranslate name="invitation-read-more" fallback="Read more about the experience" />
                                            </Link>
                                        </div>
                                    </StatusPending>


                                    <StatusDeclined invitation={props.invitation}>
                                        <div className="invitation-intro">
                                            <p><TextTranslate name="invitation-declined-msg" fallback="We are sorry to hear that you won’t be able to join us as a NEOM guest at the" /> <Translate model={event} field="name" />!</p>
                                            <p>
                                                <TextTranslate name="invitation-declined-socialmedia" fallback="To keep up to date with the latest team & NEOM news - please follow us on social media:" textOnly />
                                            </p>
                                            <div>
                                                <a href="https://www.instagram.com/discoverneom/?hl=en" target="_blank" className="link text-primary">Instagram</a>
                                                <span className="d-inline-block text-color-gray pr-3 pl-3">|</span>
                                                <a href="https://twitter.com/NEOM?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank" className="link text-primary">Twitter</a>
                                            </div>
                                            
                                        </div>
                                    </StatusDeclined>

                                    <StatusConfirmed invitation={props.invitation}>
                                        <div className="invitation-intro">
                                            <p><TextTranslate name="invitation-accepted-msg" fallback="We are delighted to hear that you will be joining us as a NEOM guest at the"/> <Translate model={event} field="name" /> <TextTranslate name="taking place in" fallback="taking place in"/> <Translate model={event} field="location" />!</p>

                                            <p>
                                                <TextTranslate name="invitation-accepted-msg-progress" fallback={`You can see your registration progress and your documents below, as well as read more about <a href="/experience" class="link text-primary">the experience</a> and <a href="/partnership" class="link text-primary">the partnership</a>`} />.
                                            </p>
                                        </div>
                                    </StatusConfirmed>
                                </div>

                            </div>
                            <div className="col-lg-5 col-12 col-right">
                                <div className="row event-info-card">
                                    <div className="col-12">
                                        <label>
                                            <TextTranslate name="invitation-card-field1" fallback="Experience Type"/>
                                        </label>
                                        <p className="value"><Translate model={props.invitation.package} field="name" /></p>
                                        <hr/>
                                    </div>
                                    <div className="col-12">
                                        <label>
                                            <TextTranslate name="invitation-card-field2" fallback="Event Date"/>
                                        </label>
                                        <p className="value">
                                            <Moment locale={currentLanguage.code} format="DD/MM/YYYY">{wave.date_from}</Moment>
                                            {wave.date_from !== wave.date_to ? <>
                                                {" - "}
                                                <Moment locale={currentLanguage.code} format="DD/MM/YYYY">{wave.date_to}</Moment>
                                            </>:null}
                                        </p>
                                        <hr/>
                                    </div>
                                    <div className="col-12">
                                        <label>
                                            <TextTranslate name="invitation-card-field3" fallback="Number of Invitees"/>
                                        </label>
                                        <p className="value">{props.invitation.guest_allowance}</p>
                                        <hr/>
                                    </div>
                                    <div className="col-12">
                                        <label>
                                            <TextTranslate name="invitation-card-field4" fallback="Your Experience"/>
                                        </label>
                                        <ul className="ticked">
                                            {props.invitation.package.experiences.map(e => (
                                                <li key={e.id}><Translate model={e} field="name" /></li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="col-12">
                                        <p className="value"><strong><TextTranslate name="word-please-note" fallback="Please note"/>:</strong> <TextTranslate name="invitation-flight-note" fallback="Flights will need to be booked at your own expense."/></p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <RegisterShortcut />
        </Layout>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    auth: state.auth.auth,
    invitation: state.invitation.data,
    invitation_loaded: state.invitation.loaded,
});

export default connect(mapStateToProps)(Invitation);
